<template>
  <div class="box">
    <el-form-item label="控件名称">
      <el-input v-model="editing.data.title" clearable @blur="change" @change="change"></el-input>
    </el-form-item>
    <el-form-item label="控件说明">
      <el-input type="textarea" :rows="4" placeholder="请输入内容" v-model="editing.data.placeholder"> </el-input>
    </el-form-item>
    <el-form-item label="其他">
      <el-checkbox v-model="editing.data.require">必填</el-checkbox>
    </el-form-item>

    <el-form-item label="控件类型">
      <div>{{ editing.name }}</div>
    </el-form-item>
  </div>
</template>
<script>
export default {
  name: 'TextSetting',
  props: {
    editing: Object
  },
  methods: {
    change() {
      if (!this.editing.data.title) {
        this.editing.data.title = this.editing.name
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.box {
  padding-top: 20px;
}
</style>
